<template>
  <div>
    <ProcessDictionaryDesc :pdProcessDictCode="pdProcessDictCode" />

    <div v-loading="loading">
      <div class="d-flex align-items-center mt-4">
        <div class="side-frame-success mr-2"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('form_title_fabricSet') || '面料设置' }}
          </span>
        </div>
      </div>

      <el-form
        class="mt-2"
        ref="form"
        :model="formData"
        :disabled="disabled"
        :rules="rules"
        label-width="100px"
        label-position="left"
      >
        <div>
          <el-form-item
            :label="$l('form_label_fabricCategory') || '面料大类'"
            prop="fabricCategoryCode"
          >
            <fabric-category-cascader
              size="mini"
              :lastValue.sync="formData.fabricCategoryCode"
              :valueString.sync="formData.displayCategoryCode"
              :pathLabels.sync="formData.displayCategoryName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item
            :label="$l('form_label_fabricNameRange') || '面料名称'"
            prop="fabricNameRangeArray"
          >
            <dict-select
              v-model="formData.fabricNameRangeArray"
              url="/digitalCenter/master/fabric/attributes/attributesSelect"
              :body="fabricNameRangeParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              multiple
              filterable
              :options="{ label: 'label', value: 'this' }"
              size="mini"
            ></dict-select>
          </el-form-item>
        </div>
      </el-form>

      <TechTable
        ref="techTable"
        :tableData="formData.listTech"
        :disabled="disabled"
      />
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import TechTable from '../tech-table'
import ProcessDictionaryDesc from '../process-dictionary-desc'
export default {
  mixins: [EditLoading],
  components: { TechTable, ProcessDictionaryDesc },
  props: {
    disabled: { type: Boolean, default: false },
    isCopy: { type: Boolean, default: false },
    pdProcessDictCode: { type: String, default: '' },
    pdProcessDictFabricCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      loading: false,
      formData: {},
      fabricNameRangeParams: { fabricAttrTypeEn: 'Fabric Description' },
      rules: {
        fabricCategoryCode: [
          { required: true, message: ' ', trigger: 'change' },
        ],
        fabricNameRangeArray: [
          { required: true, message: ' ', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.pdProcessDictFabricCode) return
      this.loading = true
      const res = await this.$api
        .processDictionaryFabricDetailApi({
          pdProcessDictFabricCode: this.pdProcessDictFabricCode,
        })
        .catch(() => {})
      this.loading = false
      this.formData = res.body || {}

      if (this.isCopy) {
        this.formData.pdProcessDictFabricCode = ''
        this.formData.fabricCategoryCode = ''
        this.formData.displayCategoryCode = ''
        this.formData.displayCategoryName = ''
        this.formData.fabricNameRange = ''
        this.formData.fabricNameRangeJson = '[]'
        this.formData.fabricNameRangeArray = []
      }
    },
    async save() {
      if (!(await this.validate())) return

      const listTech = await this.$refs.techTable.getTableData()
      const params = {
        pdProcessDictCode: this.pdProcessDictCode,
        ...this.formData,
        listTech,
      }
      this.loadingOpen()
      const res = await this.$api
        .processDictionaryFabricSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
    },
    async validate() {
      const formValidate = await validate.formValidate([this.$refs.form])
      const techTableValidate = await this.$refs.techTable.validate()
      return formValidate && techTableValidate
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  border-left: 3px solid $color-success;
  height: 26px;
  margin: 0;
  padding: 0;
}
.side-frame-warning {
  border-left: 3px solid $color-warning;
  height: 26px;
  margin: 0;
  padding: 0;
}

::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-form {
    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
    > div {
      border: 1px solid #ebeef5;
      border-top: none;

      > .el-form-item {
        margin: 0 !important;
        position: relative;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
          display: flex;
          align-items: center;
        }

        .el-form-item__content {
          padding: 0 10px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;

          > div {
            margin: 3.2px 0;
          }
        }
      }
    }
  }
}
</style>
